<template>
  <el-table-column :width="width" ref="elTableColumn" :type="type" :align="align" :min-width="minWidth" :resizable="resizable" :label="label" :show-overflow-tooltip="showOverflowTooltip">
    <template slot-scope="scope">
      <template v-if="$scopedSlots.default">
        <slot :row="scope.row" :column="scope.column" :$index="scope.$index" />
      </template>
      <template v-else>
        <span tabindex="0" :aria-label="ariaLabel ? ariaLabel : ariaLabelText(scope)">{{text(scope)}}</span>
      </template>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    name: 'CustTableColumn',

    props: {
      width: {
        type: String,
        default: ''
      },
      minWidth: {
        type: String,
        default: ''
      },
      align: {
        type: String,
        default: ''
      },
      type: {
        type: String,
        default: ''
      },
      resizable: Boolean,
      ariaLabel:String,
      prop:String,
      label:String,
      showOverflowTooltip:Boolean,
      formatter:Function,
      dataMap:Array
    },

    data() {
      return {
        visibleInner: false,
        originWindowLoadFun: null,
        originFocus: null
      }
    },

    computed: {
      ariaLabelText(){
        return (scope)=>{
          return `${this.$props.label}:${this.text(scope)}`;
        }
      },
      text(){
        return (scope)=>{
          let value;
          if(this.$props.formatter){
            value = this.$props.formatter(scope.row, scope.$index);
          }else{
            value = scope.row[this.$props.prop];
          }
          if(this.$props.dataMap){
            const info = this.$props.dataMap.find(item => item.value === value)
            if(info){
              value = info.name
            }
          }
          if(typeof value === 'boolean'){
            return value ? `是` : `否`;
          }
          return value
        }
      }
    },
    watch: {
    },
    beforeMount() {
    },
    mounted() {
    },

    destroyed() {},

    methods: {
    }
  }
</script>
<style rel="stylesheet/scss" lang="scss"></style>
